import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "set-custom-routes"
    }}>{`Set custom routes`}</h1>
    <p>{`You can configure REST endpoints in your module to use custom routes (aliases) for URLs instead of the default URLs. For example, you can define the alias `}<inlineCode parentName="p">{`createWidget`}</inlineCode>{` to represent `}<inlineCode parentName="p">{`POST V1/widgets`}</inlineCode>{`. However, you cannot create an alias for a route that contains one or more variables, such as `}<inlineCode parentName="p">{`PUT V1/widgets/:widgetId`}</inlineCode>{`.`}</p>
    <p>{`To define custom routes, create an `}<inlineCode parentName="p">{`etc/webapi_async.xml`}</inlineCode>{` file in your module that contains the following structure:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<services xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:module:Magento_WebapiAsync:etc/webapi_async.xsd">
    <route url="V1/widgets" method="POST" alias="createWidget" />
    <route url="async/bulk/V1/widget" method="PUT" alias="asyncBulkUpdateWidgets"/>
    .........
</services>
`}</code></pre>
    <p>{`This example redefines two routes:`}</p>
    <ul>
      <li parentName="ul">{`All requests made on endpoint `}<inlineCode parentName="li">{`POST /createWidget`}</inlineCode>{` will be forwarded to `}<inlineCode parentName="li">{`POST V1/widgets`}</inlineCode></li>
      <li parentName="ul">{`All requests made on endpoint `}<inlineCode parentName="li">{`PUT /asyncBulkUpdateWidgets`}</inlineCode>{` will be forwarded to `}<inlineCode parentName="li">{`PUT async/bulk/V1/widget`}</inlineCode></li>
    </ul>
    <p>{`The following table defines the `}<inlineCode parentName="p">{`route`}</inlineCode>{` node attributes:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An existing REST endpoint. The route can be defined in the module's `}<inlineCode parentName="td">{`webapi.xml`}</inlineCode>{` file, or derived, such as those for asynchronous and bulk endpoints.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`method`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The HTTP request method. One of `}<inlineCode parentName="td">{`GET`}</inlineCode>{`, `}<inlineCode parentName="td">{`PUT`}</inlineCode>{`, `}<inlineCode parentName="td">{`POST`}</inlineCode>{` or `}<inlineCode parentName="td">{`DELETE`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`alias`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string that defines the custom route for the route defined in `}<inlineCode parentName="td">{`url`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      